export const DARK_MODE = "DARK_MODE";
export const SORTING_A_TO_Z = "SORTING_A_TO_Z";
export const SORTING_Z_TO_A = "SORTING_Z_TO_A";
export const GET_COUNTRIES = "GET_COUNTRIES";
export const GET_PHOTOS = "GET_PHOTOS";
export const GET_COUNTRY = "GET_COUNTRY";
export const SEARCH_COUNTRY = "SEARCH_COUNTRY";
export const LOADING = "LOADING";
export const ADD_FAVOURITE = "ADD_FAVOURITE";
export const REMOVE_FAVOURITE = "REMOVE_FAVOURITE";
export const AREA_ASC = "AREA_ASC";
export const AREA_DSC = "AREA_DSC";
export const POP_ASC = "POP_ASC";
export const POP_DSC = "POP_DSC";
export const REGION_EURO = "REGION_EURO";
export const fetchCountries = "fetchCountries";
export const fetchCountry = "fetchCountry";
export const fetchPhoto = "fetchPhoto";
